import {gql} from 'graphql-request';
import {useGqlRequest} from '@/api/request';
import {
  AnalysisItem,
  KodataCategoryGroup,
  KodataCustomerGenderAgeData,
} from '@/map/@types';
import {useQuery} from '@tanstack/react-query';
import {getAreaQueryVariables} from './variables';

export const useCustomerGenderAge = (
  item: AnalysisItem,
  categories: KodataCategoryGroup[]
) => {
  const id = item?.id;
  const enabled = !!id && !!categories?.length;

  const request = useGqlRequest({
    query: CUSTOMER_GENDER_AGE_BY_POINT,
  });

  const queryFn = ():
    | undefined
    | Promise<{
        result?: {ageGender: KodataCustomerGenderAgeData};
      }> => {
    const variant = getAreaQueryVariables(item);

    if (!variant) {
      return;
    }

    return request({...variant, categories});
  };

  const select = (data?: {result?: {ageGender: KodataCustomerGenderAgeData}}) =>
    data?.result?.ageGender;

  return useQuery({
    enabled,
    queryKey: ['map', 'analytics', id, 'customer-gender-age', categories],
    queryFn,
    select,
  });
};

const CUSTOMER_GENDER_AGE_BY_POINT = gql`
  query areaCompareSalesByPoint(
    $categories: [Category!]!
    $lat: Float!
    $lng: Float!
    $radius: Float!
  ) {
    result: areaCompareSalesByPoint(
      categories: $categories
      lat: $lat
      lng: $lng
      radius: $radius
    ) {
      ageGender {
        femaleAgeGender
        maleAgeGender
      }
    }
  }
`;
